var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { UXPContext } from "@core/context/Context";
/**
 * This hook is used to update the default props of a given widget instance.
 * This returns a function  (instanceId : string, props : any ) => void
 * instanceId: widget instance. can access this from props of the widget
 * props: default props that you ant to set (
 *      NOTE: you have to specify all the default props here
 *      NOTE: you can pass default props when registering a widget
 * )
 *
 * This function will update the default props. But it won't re-render your widget. you have to handle that manually (maybe for now :))
 * @export
 */
const useUpdateWidgetProps = () => {
    const context = React.useContext(UXPContext);
    function updateWidgetProps(instanceId, props) {
        return __awaiter(this, void 0, void 0, function* () {
            // let installed = context.widgetManager.getInstalledWidgets()
            // let deleted = context.widgetManager.getDeletedWidgets()
            // // update
            // let updated = installed.map((w) => {
            //     if (w.layout.i == instanceId) {
            //         w.defaultProps = props
            //     }
            //     return w
            // })
            // await context.onConfigurationChanges({
            //     widgets: {
            //         installed: updated,
            //     }
            // })
        });
    }
    return updateWidgetProps;
};
export default useUpdateWidgetProps;
